import React from 'react';

const CalendarIcon = () => (
  <svg
    width='13'
    height='14'
    viewBox='0 0 13 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.25 1H10V0.75C10 0.551088 9.92098 0.360322 9.78033 0.21967C9.63968 0.0790177 9.44891 0 9.25 0C9.05109 0 8.86032 0.0790177 8.71967 0.21967C8.57902 0.360322 8.5 0.551088 8.5 0.75V1H4V0.75C4 0.551088 3.92098 0.360322 3.78033 0.21967C3.63968 0.0790177 3.44891 0 3.25 0C3.05109 0 2.86032 0.0790177 2.71967 0.21967C2.57902 0.360322 2.5 0.551088 2.5 0.75V1H1.25C0.918479 1 0.600537 1.1317 0.366117 1.36612C0.131696 1.60054 0 1.91848 0 2.25V12.25C0 12.5815 0.131696 12.8995 0.366117 13.1339C0.600537 13.3683 0.918479 13.5 1.25 13.5H11.25C11.5815 13.5 11.8995 13.3683 12.1339 13.1339C12.3683 12.8995 12.5 12.5815 12.5 12.25V2.25C12.5 1.91848 12.3683 1.60054 12.1339 1.36612C11.8995 1.1317 11.5815 1 11.25 1ZM2.5 2.5C2.5 2.69891 2.57902 2.88968 2.71967 3.03033C2.86032 3.17098 3.05109 3.25 3.25 3.25C3.44891 3.25 3.63968 3.17098 3.78033 3.03033C3.92098 2.88968 4 2.69891 4 2.5H8.5C8.5 2.69891 8.57902 2.88968 8.71967 3.03033C8.86032 3.17098 9.05109 3.25 9.25 3.25C9.44891 3.25 9.63968 3.17098 9.78033 3.03033C9.92098 2.88968 10 2.69891 10 2.5H11V4H1.5V2.5H2.5ZM1.5 12V5.5H11V12H1.5Z'
      fill='#171717'
      fillOpacity='0.7'
    />
  </svg>
);

export default CalendarIcon;
